import React, { useState } from 'react';
import Modal from 'react-modal';
import imageCross from "../../src/Images/crosspng.png";
import imageUpNotFilled from "../../src/Images/down-unfilled-up.png";
import imageDownFilled from '../../src/Images/downFilledpng.png';
import imageUpFille from "../../src/Images/filled-up-png.png";
import imageThumpUpEmpty from '../../src/Images/imageThumpUpempty.png';
import imageTick from '../../src/Images/tickpngHighSize.png';
import '../../src/styles/modal-style.css';

const customHTMLElement = {content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  }}
function ModalBox(props) {
  const {modalType = "", description="", statusDes=false, subHead} = props
  const {heading, open, List, onChange } = props;
  const [like, setLike] = useState(true);
  const [unlike, setUnlike] = useState(true);
  const eventOrganiser = (eventType) =>{
    if(eventType === 'close'){
      onChange(false)
    }
    else if(eventType === 'down') {
      setLike(false)
      setTimeout(()=>{onChange( false)}, 1000)
    }
    else if(eventType === 'up' ) {
      setUnlike(false)
      setTimeout(()=>{onChange()}, 1000)
    }
    else if(eventType === 'description' ) {
      setUnlike(false)
      setTimeout(()=>{onChange()}, 1000)
    }
  }

  return (
    <>
         <Modal
        isOpen={open}
        onRequestClose={()=>{eventOrganiser('close')}}
        onClose={()=>{ onChange()}}
        contentLabel="Example Modal"
        style={customHTMLElement}
        ariaHideApp={false} 
      >
        <div className="popup-box-center">
          <div className={statusDes ===  true ? "popup-div descriptionPadding":"popup-div notDescriptionPadding"}>
            <div className="modal-header">
              
              <div className="cross">
                <img onClick={()=>{eventOrganiser('close')}} src={imageCross} className="crossImage" />
              </div>
            </div>
            <div className="list-section">
              <span class="headSpanDescriptionCond"> {heading} </span>
               {subHead !== "" ? <>
                   <div className="section-subhead">
                      {subHead}
                    </div>
               </> :<></>}
               <div className='someCenter'>
              <div className="pt-3 modalTickSection">
              
                  {modalType === 'description' ? <>
                     <span className=" section-span-description">
                      {description}
                    </span>
                  </>:<>
                  {List?.map((word, index) => {
                return (
                  <div key={index} className="tickSection">
                    <img src={imageTick} style={{height:'14px', width:'14px', borderRadius:'50%'}}  /> 
                    <span className="section-span">
                      {word}
                    </span>
                  </div>
                );
              })}
                  </>}
               
              
              </div>
              </div>
      
            </div>
            <div>
              <p className="popup-p-text">Was this information helpful?</p>
              <div className="like-unlike-section">
                 {unlike ? (
                  <img onClick={()=>{eventOrganiser('up')}} src={imageThumpUpEmpty} />
                ) : (
                  <img src={imageUpFille} />
                )}
                {like ? (
                  <img onClick={()=>{eventOrganiser('down') }} src={imageUpNotFilled } />
                ) : (<img src={imageDownFilled} />)}
               
              </div>
            </div>
          </div>
        </div>
        </Modal>
    </>
  );
}

export default ModalBox;